import { VideoPlayer } from "best-common-react";
import React from "react";

const Video = ({ url }) => {
  return <VideoPlayer url={url} width="100%" height="100%" />;
};

export default Video;
